import SectionHeading from "@/pages/home/components/SectionHeading";
import { contentPillars } from "@/mocks/content";

export default function Overview() {
  return (
    <section id="overview" className="w-full bg-background-50 py-16 md:py-24 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="平台内容构成"
          title="快猫的内容由三块组成"
          desc="在开始浏览之前，先弄清平台内容的三种形态与它们的组织方式，能省下大量盲刷的时间。下面三块是理解整个平台的基础。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {contentPillars.map((p, idx) => (
            <article
              key={p.title}
              className="group relative rounded-lg bg-background-100 border border-background-200/80 p-6 md:p-7 hover:border-primary-300 transition-colors"
            >
              <span className="absolute top-6 right-6 font-heading font-black text-4xl text-background-300 select-none">
                0{idx + 1}
              </span>
              <span className="inline-flex w-12 h-12 items-center justify-center rounded-lg bg-primary-100 text-primary-700 text-2xl">
                <i className={p.icon}></i>
              </span>
              <div className="mt-4 inline-flex items-center gap-1.5 text-[11px] text-secondary-800 bg-secondary-100 px-2.5 py-1 rounded-full">
                {p.tag}
              </div>
              <h3 className="mt-3 font-heading font-bold text-xl text-foreground-950">{p.title}</h3>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{p.desc}</p>
              <ul className="mt-5 space-y-2 border-t border-background-200 pt-5">
                {p.points.map((pt) => (
                  <li key={pt} className="flex items-start gap-2 text-sm text-foreground-700">
                    <i className="ri-checkbox-circle-fill text-accent-500 mt-0.5"></i>
                    {pt}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        <div className="mt-6 md:mt-8 rounded-lg bg-accent-50 border border-accent-200/70 p-5 md:p-6 flex flex-col sm:flex-row items-start gap-4">
          <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-lg bg-accent-500 text-background-50 text-xl">
            <i className="ri-lightbulb-line"></i>
          </span>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
            <strong className="text-foreground-950">浏览建议：</strong>
            先确定自己是想「实时互动」还是「快速扫看」。想看直播就去
            <a href="#live" className="text-primary-600 font-medium mx-1 cursor-pointer hover:underline">直播分区</a>
            按类型筛选；想快速刷内容就去
            <a href="#video" className="text-primary-600 font-medium mx-1 cursor-pointer hover:underline">短视频题材</a>
            按标签筛选。福利内容的入口与权限说明在
            <a href="#welfare" className="text-primary-600 font-medium mx-1 cursor-pointer hover:underline">观看方式</a>
            一节。
          </p>
        </div>
      </div>
    </section>
  );
}